import { render, staticRenderFns } from "./disable.vue?vue&type=template&id=1b074c5d&scoped=true&"
import script from "./disable.vue?vue&type=script&lang=js&"
export * from "./disable.vue?vue&type=script&lang=js&"
import style0 from "./disable.vue?vue&type=style&index=0&id=1b074c5d&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b074c5d",
  null
  
)

export default component.exports